import { Link, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import EventGallery from "../components/EventGallery";
import { GET_EVENT } from "../graphql/queries";
import { Event } from "../types";

function EventDetail() {
  const { id } = useParams<{ id: string }>();
  const { data, loading, error } = useQuery<{ event: Event }>(GET_EVENT, {
    variables: { id },
    skip: !id,
  });

  if (loading) return <p className="body-text">Loading event...</p>;
  if (error) return <p className="body-text">Error: {error.message}</p>;
  if (!data?.event) return <p className="body-text">Event not found.</p>;

  const event = data.event;

  return (
    <article>
      <Link to="/events" className="body-text">← Back to events</Link>
      <EventGallery
        key={event.id}
        featuredImageUrl={event.heroImageUrl}
        galleryImageUrls={event.galleryImageUrls}
        title={event.title}
      />
      <h1 className="display-text" style={{ fontSize: 42, marginTop: 24 }}>
        {event.title}
      </h1>
      <p className="h2-text" style={{ margin: "8px 0 24px" }}>
        {event.eventType}
        {event.date && ` · ${event.date}`}
        {event.location && ` · ${event.location}`}
      </p>
      <p className="body-text">{event.description}</p>
    </article>
  );
}

export default EventDetail;
